import {
    tns
} from 'tiny-slider/src/tiny-slider';
var sliders = {};
const authService = require("../../../services/auth");

export const start = async function(tabsContainerId) {

    var slider = tns({
        container: '.slider-ong-searcher',
        slideBy: 'page',
        autoplay: false,
        center: false,
        swipeAngle: false,
        loop: false,
        controls: false,
        responsive: {
            360: {
                items: 1,
                fixedWidth: false,
                autoWidth: true,
                gutter: 0,
                edgePadding: 0,
                controls: false,
                nav: true,
                navPosition: 'bottom',
            },
        }
    });

    sliders = slider;

    setTimeout(() => {

        var tabs = document.getElementById(tabsContainerId)
        if (tabs) {
            tabs = tabs.getElementsByClassName('tab');
            Array.from(tabs).forEach((tab, i) => {
                tab.addEventListener("click", (e) => changeTab(tabsContainerId, i))
            });
        }



        Array.from(document
            .getElementsByClassName("page-item")).forEach((el, i) => {
            el.addEventListener("click", (e) => changePage(el.getAttribute("page")))
        });


    }, 100)


}


//chared functions

function changeTab(tabsContainerId, activedIndex) {
    console.log('tabsContainerId, activedIndex', tabsContainerId, activedIndex)
    var tabs = document.getElementById(tabsContainerId)
    tabs = Array.from(tabs.getElementsByClassName('tab'));

    var tabsContents = document.getElementById(`${tabsContainerId}Content`)
    tabsContents = Array.from(tabsContents.getElementsByClassName('tabContent'));


    tabs.forEach((tab, i) => {
        if (i == activedIndex) {
            tab.classList.add('active');
            tabsContents[i].classList.add('active');
        } else {
            tab.classList.remove('active');
            tabsContents[i].classList.remove('active');
        }

    });

    // .hide {
    //     display: none;
    // }
}



async function changePage(page, tag) {
    updatePaginationBeforeServer(page);
    startLoading()

    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    var requestOptions = {
        method: 'GET',
        headers: headers
    };
    var type = document.getElementsByTagName('ong-searcher')
        type = type[0].getAttribute('type')

    var fetchServer = await fetch(`${process.env.API_URL}/${type}/list?page=${page}&profiles=true`, requestOptions)

    var posts = await fetchServer.json()
    console.log('posts: ', posts);
    addPostsToView(posts.data, page)
    updatePagination(page, posts.pagination.last_page, posts.pagination.current_page)
}


function addPostsToView(posts, page) {
    var postsHTML = "";
    var postsContainer = document.getElementById('postsContainer')
    var hotelID = postsContainer.getAttribute("hotelID")
    posts.forEach((ong) => {
        const typeCustom = `${ong.type}_entities`;
        postsHTML = `${postsHTML}
        <div class="col-md-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000"><box-ong-searcher><a class="box-ong-searcher margin-bottom-xl" href="/ong-ficha/${ong[typeCustom].id}"><div class="box-head"><div class="avatar"><img src="${ong.logo?ong.logo:'/images/icons/company_placeholder.jpg'}" alt="${ong[typeCustom].name}"></div><div class="name"><h3>${ong[typeCustom].name}</h3></div></div><div class="box-body"><div class="textContainer">Buscando doações</div><div class="buttonContainer"><span>Conhecer</span></div></div></a></box-ong-searcher></div>
        `
    })
    console.log('postsHTML', postsHTML)
    postsContainer.innerHTML = postsHTML;
    // window.history.replaceState(null, null, `${hotelID}/blog/${page}`);
}

function startLoading() {
    var postsHTML = "";
    var postsContainer = document.getElementById('postsContainer')
    const posts = [1, 2, 3, 4, 5, 6, 7, 8, 9]
    posts.forEach((post) => {
        postsHTML = `${postsHTML}<div class="col-md-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000"><box-ong-searcher><a class="box-ong-searcher margin-bottom-xl loading" href="/ong-ficha/14" style="
    background-color: #fff;
    overflow: hidden;
    border-color: #E2E2E2;
"><div class="box-head loading"><div class="avatar loading"><img src="/images/icons/company_placeholder.jpg" alt="" style="
    opacity: 0;
"></div><div class="name"><h3 class="loading">Teste Leo</h3></div></div><div class="box-body"><div class="textContainer loading">Buscando doações</div><div class="buttonContainer loading"><span class="loading">Conhecer</span></div></div></a></box-ong-searcher></div>`
    })
    postsContainer.innerHTML = postsHTML;
}

function updatePagination(page, amount, current) {
    var items = "";

    for (var i = 0; i < amount; i++) {
        items = `${items}<li class="page-item ${(i+1)==(current)?'active':''}" page="${i+1}"><a class="page-link" title="${i+1}">${i+1}</a></li>`
    }
    document.getElementById("paginacao")
        .getElementsByTagName("ul")[0].innerHTML = items;

    Array.from(document
        .getElementsByClassName("page-item")).forEach((el, i) => {
        el.addEventListener("click", (e) => changePage(el.getAttribute("page")))
    });
}

function updatePaginationBeforeServer(page) {
    Array.from(document.getElementById("paginacao").getElementsByClassName("page-item")).forEach((el, i) => {
        const pageEL = el.getAttribute("page")
        if (pageEL == page) {
            el.classList.add("active")
        } else {
            el.classList.remove("active")
        }
    });
}
